var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraNotAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15422_74742)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9102 28.9102L24.2739 33.2739M46.092 55.092L44.4128 53.3787M29.7166 30.4638C29.8541 30.4269 29.995 30.4 30.1384 30.3836C30.3034 30.3647 30.4822 30.3647 30.8398 30.3647H35.2305C35.5881 30.3647 35.7669 30.3647 35.9319 30.3836C36.7927 30.4822 37.5648 30.9593 38.0379 31.6852C38.1286 31.8243 38.2086 31.9843 38.3685 32.3041C38.4485 32.464 38.4884 32.544 38.5338 32.6136C38.7704 32.9765 39.1564 33.215 39.5868 33.2643C39.6693 33.2738 39.7587 33.2738 39.9375 33.2738H41.4715C43.1008 33.2738 43.9154 33.2738 44.5377 33.5909C45.0851 33.8698 45.5301 34.3148 45.809 34.8622C46.1261 35.4845 46.1261 36.2991 46.1261 37.9283V46.8732M44.4128 53.3787C43.8052 53.6374 42.9941 53.6374 41.4715 53.6374H24.5988C22.9695 53.6374 22.1549 53.6374 21.5326 53.3204C20.9853 53.0415 20.5402 52.5964 20.2613 52.049C19.9442 51.4267 19.9442 50.6121 19.9442 48.9829V37.9283C19.9442 36.2991 19.9442 35.4845 20.2613 34.8622C20.5402 34.3148 20.9853 33.8698 21.5326 33.5909C22.1121 33.2956 22.8584 33.2753 24.2739 33.2739M44.4128 53.3787L36.7274 45.7274M36.7274 45.7274C35.961 46.9819 34.5788 47.8192 33.0011 47.8192C30.5911 47.8192 28.6374 45.8656 28.6374 43.4556C28.6374 41.8779 29.4748 40.4957 30.7293 39.7293M36.7274 45.7274L30.7293 39.7293M30.7293 39.7293L24.2739 33.2739",
    stroke: "white",
    strokeWidth: 2.90909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.4538,
    y: 2.00071,
    width: 30.5455,
    height: 30.5455,
    rx: 15.2727,
    fill: "#F24822"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.4538,
    y: 2.00071,
    width: 30.5455,
    height: 30.5455,
    rx: 15.2727,
    stroke: "#F0FBFF",
    strokeWidth: 1.45455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8027 20.827L55.8555 8.54688H59.5957L58.6485 20.827H56.8027ZM56.0255 26.0014V22.56H59.4257V26.0014H56.0255Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15422_74742",
    x: 0,
    y: 0.273438,
    width: 76.7266,
    height: 76.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2125 0 0 0 0 0.2125 0 0 0 0 0.2125 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15422_74742"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15422_74742",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraNotAccess);
export default __webpack_public_path__ + "static/media/camera-not-access.246bd5a2e1b52762175d89963d658f2a.svg";
export { ForwardRef as ReactComponent };